import { PgInformation } from '../hooks/useGetPgInformation';

// `pgInformation` is fetched on the partner side (ClientDetail) and persisted so the
// payment screens can show the same fee/gateway the link was generated with.
export const CONVENIENCE_FEE_STORAGE_KEY = 'pgConvenienceFee';
export const PAYMENT_GATEWAY_STORAGE_KEY = 'pgPaymentGateway';

export const DEFAULT_CONVENIENCE_FEE = 19;

export const PAYMENT_GATEWAY_IDFC = 'PAYMENT_GATEWAY_IDFC';

export const savePgInformation = (pgInformation?: PgInformation) => {
  const fee = Number(pgInformation?.convenienceFee);
  if (Number.isFinite(fee)) {
    localStorage.setItem(CONVENIENCE_FEE_STORAGE_KEY, String(fee));
  }

  const paymentGateway = pgInformation?.paymentGateway;
  if (paymentGateway) {
    localStorage.setItem(PAYMENT_GATEWAY_STORAGE_KEY, paymentGateway);
  }
};

export const getStoredConvenienceFee = () => {
  const storedFee = localStorage.getItem(CONVENIENCE_FEE_STORAGE_KEY);
  const parsedFee = storedFee ? Number(storedFee) : NaN;
  return Number.isFinite(parsedFee) ? parsedFee : DEFAULT_CONVENIENCE_FEE;
};

export const getStoredPaymentGateway = () => localStorage.getItem(PAYMENT_GATEWAY_STORAGE_KEY) || '';

// The user payment screen is opened by the investor, so the partner's localStorage is not
// available there — it reads `pgInformation` off the payment link response instead.
export const resolveConvenienceFee = (pgInformation?: PgInformation) => {
  const fee = Number(pgInformation?.convenienceFee);
  return Number.isFinite(fee) ? fee : getStoredConvenienceFee();
};

// The pre-discount fee, shown struck through next to the actual fee. There is no storage
// fallback — if the response does not carry it, no strikethrough is rendered.
export const resolveStrikedConvenienceFee = (pgInformation?: PgInformation) => {
  const strikedFee = Number(pgInformation?.strikedConvenienceFee);
  return Number.isFinite(strikedFee) ? strikedFee : undefined;
};

export const resolvePaymentGateway = (pgInformation?: PgInformation) =>
  pgInformation?.paymentGateway || getStoredPaymentGateway();

export const clearStoredPgInformation = () => {
  localStorage.removeItem(CONVENIENCE_FEE_STORAGE_KEY);
  localStorage.removeItem(PAYMENT_GATEWAY_STORAGE_KEY);
};
